import { render, staticRenderFns } from "./RecommendArticle.vue?vue&type=template&id=2cf24aaf&"
import script from "./RecommendArticle.vue?vue&type=script&lang=js&"
export * from "./RecommendArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports